export default __webpack_public_path__ + "static/media/index_3.ff4f7029.png";